module.exports = __webpack_public_path__ + "img/macbook.213a0f5b.png";